var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplePayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "96px",
    height: "96px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.653,17.61c-0.559,0.684 -1.453,1.224 -2.348,1.146c-0.111,-0.924 0.327,-1.908 0.84,-2.514c0.558,-0.703 1.536,-1.204 2.328,-1.242c0.093,0.963 -0.27,1.907 -0.82,2.61M9.369,19.235c-1.304,0 -2.237,0.706 -2.846,0.706c-0.619,0 -1.542,-0.697 -2.609,-0.697c-1.304,0 -2.581,0.812 -3.255,1.996c-1.384,2.367 -0.36,5.872 0.978,7.799c0.656,0.954 1.447,1.961 2.514,1.961c0.978,-0.037 1.309,-0.588 2.49,-0.588c1.19,0 1.542,0.588 2.609,0.588c1.067,0 1.714,-0.97 2.369,-1.925c0.748,-1.082 1.052,-2.138 1.07,-2.193c-0.018,-0.018 -2.066,-0.798 -2.085,-3.147c-0.018,-1.963 1.615,-2.9 1.689,-2.955c-0.923,-1.357 -2.45,-1.546 -2.805,-1.546h-0.119zM22.688,17h-5.438v13.999h2.265v-4.666h3.099c2.844,0 4.887,-1.937 4.887,-4.666c0,-2.729 -2.006,-4.667 -4.813,-4.667zM22.137,24.466h-2.622v-5.6h2.622c1.952,0 3.099,1.031 3.099,2.8c0,1.769 -1.138,2.8 -3.099,2.8zM32.752,20.5c-2.39,0 -4.156,1.324 -4.222,3.144h2.027c0.167,-0.865 0.995,-1.432 2.13,-1.432c1.376,0 2.154,0.621 2.154,1.766l0.001,0.79l-2.814,0.147c-2.614,0.153 -4.028,1.19 -4.028,2.992c0,1.82 1.46,3.028 3.552,3.028c1.413,0 2.725,-0.693 3.319,-1.793h0.046v1.685h2.083v-6.992c0.001,-2.029 -1.673,-3.335 -4.248,-3.335zM34.834,27.014c0,1.316 -1.153,2.253 -2.678,2.253c-1.199,0 -1.962,-0.559 -1.962,-1.414c0,-0.883 0.734,-1.396 2.139,-1.478l2.508,-0.184zM45.691,20.5l-2.675,8.588h-0.046l-2.676,-8.588h-2.374l3.848,10.584l-0.206,0.644c-0.348,1.091 -0.91,1.511 -1.914,1.511c-0.172,0 -0.497,-0.017 -0.647,-0.036v1.745c0.151,0.034 0.679,0.052 0.843,0.052c2.215,0 3.256,-0.839 4.167,-3.385l3.989,-11.115z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePayLogo);
export default __webpack_public_path__ + "static/media/applePay-logo.2ba3e6bd89ab880e56f865e643537d11.svg";
export { ForwardRef as ReactComponent };